<template>
  <form enctype="multipart/form-data" novalidate>
    <template v-if="dropzone">
      <vue-dropzone ref="dz" id="logo" :options="dropOptions" @vdropzone-sending="onFileSending" @vdropzone-success="onFileDone" @vdropzone-error="onFileError"></vue-dropzone>
    </template>
    <div v-else class="uploader" :class="{'less-width': !showHint, 'display-none': dropzone}">
      <input type="file"
             class="form-input-styled"
             data-fouc=""
             ref="fileInput"
             :multiple="multiple"
             :name="uploadFieldName"
             @change="filesChange($event.target.name, $event.target.files)"
             :accept="accept">
      <span class="filename" style="user-select: none;" v-if="showHint && !fileCount">No file selected</span>
      <span class="filename" style="user-select: none;" v-if="showHint && fileCount > 1 && multiple">{{fileCount}} files</span>
      <span class="filename" style="user-select: none;" v-if="showHint && fileCount && (!multiple || fileCount === 1)">{{lastFile.data.name}}</span>
      <span :class="{'action btn bg-warning': showButtonBg, 'action cursor-pointer': !showButtonBg}" style="user-select: none;"><i v-if="labelIconClass" :class="labelIconClass"></i> {{label}}</span>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import UploadService from '@/services/upload.service'
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import pace from 'pace-progress'

export default {
  name: 'UploadForm',
  components: { vueDropzone },
  props: {
    uploadUrl: {
      type: [String, null]
    },
    uploadFieldName: {
      type: String,
      default: 'files'
    },
    accept: {
      type: String,
      default: '*/*'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Choose file'
    },
    showHint: {
      type: Boolean,
      default: true
    },
    labelIconClass: {
      type: String,
      default: null
    },
    fileSlot: {
      type: [String, null],
      default: null
    },
    showButtonBg: {
      type: Boolean,
      default: true
    },
    dropzone: {
      type: Boolean,
      default: false
    },
    dropzoneClearOnUpload: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      files: [],
      fileCount: 0,
      service: null,
      lastFile: null,
      serviceUrl: null,
      dropOptions: {
        url: '',
        withCredentials: true,
        paramName: 'files'
      }
    }
  },
  beforeMount () {
    this.dropOptions.url = this.serviceUrl
    this.dropOptions.headers = { 'Authorization': 'Bearer ' + this.$store.getters.isLoggedIn }
    if (this.dropzone) {
      let $vm = this
      this.dropOptions['init'] = function () {
        this.on('sending', function (file, xhr, formData) {
          pace.restart()
          formData.append('slot', $vm.fileSlot)
        })
      }
    }
  },
  methods: {
    filesChange (fieldName, fileList) {
      this.fileCount = fileList.length
      this.$logger.log('fileList', fileList)
      this.$logger.log('files', this.files)

      // handle file changes
      if (!fileList.length) return

      if (this.files.length > 0) {
        // return
      }

      if (!this.multiple) {
        this.files = []
      }

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          let file = {
            data: fileList[x],
            slot: this.fileSlot
          }
          this.lastFile = file
          this.files.push(file)
          this.service.addFile(file)
        })

      this.$refs.fileInput.value = ''
    },

    onFileSending (file) {
      this.$emit('uploadStarted', file)
    },

    onFileDone (file) {
      if (this.dropzone && this.dropzoneClearOnUpload) {
        this.$refs.dz.removeFile(file)
      }
      if (typeof file === 'object' && file.hasOwnProperty('xhr')) {
        file = JSON.parse(file.xhr.response)
        if (Array.isArray(file)) {
          file = { 'uploaded': file[0] }
        }
      }
      this.$emit('uploadComplete', file)
    },

    onFileError (file) {
      this.$emit('uploadError', file)
    }
  },

  created () {
    this.serviceUrl = this.uploadUrl || Vue.config.endpoints.upload.files
    this.service = new UploadService({
      uploadUrl: this.serviceUrl,
      fieldName: this.uploadFieldName,
      onFileDone: this.onFileDone,
      onFileError: this.onFileError
    })
  }
}
</script>

<style scoped>

</style>
